import CollectionsStore from '@/collection/stores/CollectionsStore';
import useStore from '@/common/hooks/useStore';
export const useCollectionsStore = () => useStore(CollectionsStore);
